module.exports = __webpack_public_path__ + "img/scale_mid.8f2c2130.svg";